module.exports = __webpack_public_path__ + "img/m17.5dd4228.jpg";